import { render } from "./CloseToolIcon.vue?vue&type=template&id=42a112a7"
import script from "./CloseToolIcon.vue?vue&type=script&lang=js"
export * from "./CloseToolIcon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__